import { createApi } from '@reduxjs/toolkit/dist/query/react';

import {
  createbusinessType,
  CreatebusinessTypeMutation,
  CreatebusinessTypeMutationVariables,
  createindustryType,
  CreateindustryTypeMutation,
  CreateindustryTypeMutationVariables,
  listBusinessType,
  listIndustryType,
} from '../../../graphql';
import { RTK_CACHE_LIFETIME } from '../../../config';
import { BusinessType, IndustryType } from '../../../types';
import { baseQuery } from '../../../utils';

// Define the response type for listBusinessType query
interface ListBusinessTypeResponse {
  listBusinessType: BusinessType[];
}
interface ListIndustryTypeResponse {
  listIndustryType: IndustryType[];
}

export const BuzIndTypeApi = createApi({
  reducerPath: 'buzIndTypeApi',
  baseQuery: baseQuery,
  tagTypes: ['businessType', 'industryType'],

  endpoints: (builder) => ({
    getBusinessOptions: builder.query<BusinessType[], void>({
      query: () => ({ body: listBusinessType }),
      providesTags: ['businessType'],
      keepUnusedDataFor: RTK_CACHE_LIFETIME,

      transformResponse: (response: ListBusinessTypeResponse) => {
        return (
          response?.listBusinessType?.map((item: BusinessType) => ({
            businesstype: item.businesstype || '',
            businesstypeid: item.businesstypeid || 0,
            isactive: item.isactive || 0,
          })) || []
        );
      },
    }),
    getIndustryOptions: builder.query<IndustryType[], void>({
      query: () => {
        return { body: listIndustryType };
      },
      providesTags: ['industryType'],
      keepUnusedDataFor: RTK_CACHE_LIFETIME,
      transformResponse: (response: ListIndustryTypeResponse) => {
        return (
          response?.listIndustryType?.map((item: IndustryType) => ({
            industrytype: item.industrytype || '',
            industrytypeid: item.industrytypeid || 0,
            isactive: item.isactive || 0,
          })) || []
        );
      },
    }),
    createBusinessOptions: builder.mutation<CreatebusinessTypeMutation, CreatebusinessTypeMutationVariables>({
      query: (variables) => ({ body: createbusinessType, variables }),
      invalidatesTags: ['businessType'],
    }),
    createIndustryOptions: builder.mutation<CreateindustryTypeMutation, CreateindustryTypeMutationVariables>({
      query: (variables) => ({ body: createindustryType, variables }),
      invalidatesTags: ['industryType'],
    }),
  }),
});

export const {
  useGetBusinessOptionsQuery,
  useLazyGetBusinessOptionsQuery,
  useGetIndustryOptionsQuery,
  useLazyGetIndustryOptionsQuery,
  useCreateBusinessOptionsMutation,
  useCreateIndustryOptionsMutation,
  usePrefetch,
} = BuzIndTypeApi;
